export default "__VITE_ASSET__ChzYy11s__"